import { OnboardingSnapShot } from "@/components/Organisms/OnboardingFloatingView/types";

const onboardingDataKey = "occ_onboardingData";

export function saveOnboardingSnapShot(params: OnboardingSnapShot) {
  localStorage.setItem(onboardingDataKey, JSON.stringify(params));
}

export function getOnboardingSnapShot(): OnboardingSnapShot | null {
  const onboardingSnapShotJson = localStorage.getItem(onboardingDataKey);
  return onboardingSnapShotJson && JSON.parse(onboardingSnapShotJson);
}

export function removeOnboardingSnapShot() {
  localStorage.removeItem(onboardingDataKey);
}
